import React from 'react'
import PropTypes from 'prop-types'
import { components as ReactSelectComponents } from 'react-select'

/*
 * Custom react-select Input that forwards paste events to the parent through
 * SelectProps.onPasteEmails (react-select's documented escape hatch for custom
 * Components). Kept in its own file to satisfy the project's one-component-
 * Per-file rule.
 */
const EmailPasteableInput = props => {
  const handlePaste = props.selectProps.onPasteEmails
  return <ReactSelectComponents.Input {...props} onPaste={handlePaste} />
}

EmailPasteableInput.propTypes = {
  selectProps: PropTypes.shape({
    onPasteEmails: PropTypes.func.isRequired
  }).isRequired
}

export default EmailPasteableInput
